import { Box, Divider, Flex, IconButton, Text, Tooltip, VStack, XOutline } from '@bonusly/design-system';

import { ConnectorsSection } from './components/connectors/connectors-section';
import { MemoriesSection } from './components/memories/memories-section';

interface BizySettingsProps {
	onBack: () => void;
}

export const BizySettings = ({ onBack }: BizySettingsProps) => {
	return (
		<Flex direction="column" h="100%">
			<Flex align="center" justify="space-between" pl={4} pr={3} py={3} flexShrink={0}>
				<Text fontWeight="semibold" fontSize="sm" color="text.default">
					Bizy Settings
				</Text>
				<Tooltip label="Close settings" hasArrow={false}>
					<IconButton
						aria-label="Close settings"
						icon={<XOutline boxSize={5} />}
						variant="ghost"
						size="sm"
						color="secondary.fg"
						_hover={{ bg: 'secondary.bgAlpha' }}
						onClick={onBack}
					/>
				</Tooltip>
			</Flex>

			<Box flex={1} overflowY="auto" px={4} pb={4}>
				<VStack spacing={6} align="stretch">
					<MemoriesSection />
					<Divider />
					<ConnectorsSection />
				</VStack>
			</Box>
		</Flex>
	);
};
